import React from 'react';
import { Alert, Box, Grid, Typography } from "@mui/material";
import { FormOperacionControlOperativoDetalle } from "../types/types";
import {OperacionControlOperativoDetalleFields} from "../types/fields";

interface ControlOperativoDetalleProps {
  detalle?: FormOperacionControlOperativoDetalle;
}

function ControlOperativoDetalle({ detalle }: ControlOperativoDetalleProps) {
  return (
    <Box>
      <Grid container spacing={2}>
        {
          detalle ?
            <>
              <Grid item xs={12}>
                <Typography variant='body2'>Sociedad</Typography>
                <Typography variant='body1'>
                  {detalle[OperacionControlOperativoDetalleFields.Sociedad]}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='body2'>Control</Typography>
                <Typography variant='body1'>
                  {detalle[OperacionControlOperativoDetalleFields.Control]}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='body2'>Descripción</Typography>
                <Typography variant='body1'>
                  {detalle[OperacionControlOperativoDetalleFields.Descripcion]}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='body2'>Conclusión</Typography>
                <Typography variant='body1'>
                  {detalle[OperacionControlOperativoDetalleFields.Conclusion]}
                </Typography>
              </Grid>
            </>
            : <Alert severity='info'>No se encontró detalle para esta operación.</Alert>
        }
      </Grid>
    </Box>
  );
}

export default ControlOperativoDetalle;